import React from 'react';
import { useHistory } from 'react-router-dom';
import { AppBar, IconButton, Toolbar, Menu, MenuItem } from '@material-ui/core';

import MenuIcon from '@material-ui/icons/Menu';

import { makeStyles, createStyles } from '@material-ui/core/styles';

import Logo from 'assets/images/logo-white.png';

import AuthService from 'services/axios/AuthService';
import { MdAccountCircle, MdPerson, MdPowerSettingsNew } from 'react-icons/md';

// const renderButtons = (user: firebase.User | undefined, classes: any, history: any) => {
//   if (user) {
//     return (
//       <React.Fragment>
//         <Button
//           onClick={(e) => {
//             history.push("/usuario/perfil");
//           }}
//           color="inherit"
//           className={classes.pushRight}
//         >
//           P
//         </Button>
//         <Button
//           onClick={(e) => {
//             signOut().then(() => {
//               history.push("/signin");
//             })
//           }}
//           color="inherit"
//         >
//           C
//         </Button>
//       </React.Fragment>
//     );
//   }
// };

interface ComponentProps {
  handleDrawerOpen: React.MouseEventHandler<HTMLElement>;
};

export default function Header(props: ComponentProps) {
  const classes = useStyles();
  const history = useHistory();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const navigateToEditarPerfil = () => {
    handleClose();
    history.push("/editar/perfil");
  }

  const cerrarSesion = () => {
    handleClose();
    AuthService.logout().then(() => { history.push("/login"); });
  }

  return (
    <AppBar
      position="fixed"
      className={classes.appBar}>
      <Toolbar className={classes.toolBar}>
        <IconButton
          color="inherit"
          aria-label="Open drawer"
          onClick={props.handleDrawerOpen}
          className={classes.menuButton}
        >
          <MenuIcon />
        </IconButton>
        <div className={classes.title}>
          <img src={Logo} alt="Dr. Fumigaciones" style={{ height: 29 }} />
        </div>
        <div>
          <IconButton
            aria-label="account of current user"
            aria-controls="menu-appbar"
            aria-haspopup="true"
            onClick={handleMenu}
            color="inherit"
          >
            <MdAccountCircle size={28} />
          </IconButton>
          <Menu
            id="menu-appbar"
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            keepMounted
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            open={open}
            onClose={handleClose}
          >
            <MenuItem onClick={navigateToEditarPerfil} className={classes.menuItem}>
              <MdPerson size={25} style={{ marginRight: 10 }} /> Editar Perfil
            </MenuItem>
            <MenuItem onClick={cerrarSesion} className={classes.menuItem}>
              <MdPowerSettingsNew size={25} style={{ marginRight: 10 }} /> Cerrar Sesión
            </MenuItem>
          </Menu>
        </div>
        {/* {renderButtons(user, classes, history)} */}
      </Toolbar>
    </AppBar >
  );
}

const useStyles = makeStyles(theme =>
  createStyles({
    appBar: {
      transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
    },
    logoText: {
      textDecoration: "none"
    },
    menuButton: {
      marginRight: theme.spacing(1),
      marginLeft: -1 * theme.spacing(1) / 2,
    },
    menuItem: {
      paddingRight: 32,
      paddingLeft: 16
    },
    pushRight: {
      marginLeft: "auto"
    },
    toolBar: {
      minHeight: 64
    },
    title: {
      flexGrow: 1,
    },
  }),
);